import React, { memo } from 'react'
import { Wrapper, Container } from './Style'

export const Spinner = memo(() => (
  <Wrapper>
    <Container />
  </Wrapper>
))
